module.exports = __webpack_public_path__ + "static/snigdha-f6950a9e9ef5101e828d6e22b528e3ee.jpg";